exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.tdRolloverLink[data-v-55df1fc0] {\n  margin-top: 4px;\n  text-align: center;\n  font-size: 0.9em;\n}\n", "", {"version":3,"sources":["/app/src/components/OrderTable/components/tdButton.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;CAClB","file":"tdButton.vue","sourcesContent":["\n.tdRolloverLink[data-v-55df1fc0] {\n  margin-top: 4px;\n  text-align: center;\n  font-size: 0.9em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-55df1fc0","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OrderTable/components/tdButton.vue
// module id = rkEe
// module chunks = 0